import {ThemeSpacing} from "@hps/hops-react";
import {Box} from "@mui/material";
import React from "react";

/**
 * Container component
 *
 * A generic grid container.
 *
 * @package HOPS
 * @subpackage Components
 * @copyright Heritage Operations Processing Limited
 */
const Container = props => {

	const {
		alignContent,
		alignItems,
		alignSelf,
		autoRows,
		children,
		columnar,
		columns,
		display,
		fullWidth,
		gap,
		gridAutoColumns,
		gridRowGap,
		gridTemplateRows,
		height,
		justifyContent,
		justifyItems,
		justifySelf,
		maxWidth,
		minHeight,
		order,
		overflow,
		rootRef,
		textAlign,
		singleColumn,
		style,
		width
	} = props;

	const propForwards = [
		"classes",
		"className",
		"component",
		"mb",
		"mt",
		"ml",
		"mr",
		"mx",
		"my",
		"pb",
		"pt",
		"px",
		"pr",
		"pl",
		"py"
	];


	const forwards = {};

	propForwards.forEach(forward => {
		if (props[forward]) {
			forwards[forward] = props[forward];
		}
	});


	const styles = {
		alignContent,
		alignItems,
		alignSelf,
		display: (display || "grid"),
		gap: ThemeSpacing(((gap !== undefined) ? gap : 1)),
		gridAutoColumns,
		gridAutoFlow: (columnar ? "column" : "row"),
		gridAutoRows: (autoRows || "max-content"),
		gridTemplateColumns: (singleColumn ? "100%" : columns),
		gridTemplateRows,
		height,
		justifyContent,
		justifyItems,
		justifySelf,
		maxWidth,
		minHeight,
		order,
		overflow,
		textAlign,
		width: (fullWidth ? "100%" : width),
		...style
	};

	if (gridRowGap) {
		styles.gridRowGap = ThemeSpacing(gridRowGap);
	}


	return (
		<Box {...forwards}	ref={rootRef} style={styles}>
			{children}
		</Box>
	);

};

export default Container;
